// 开发环境的商户id
const _dev_identityId = '46ic94jhpa6h';

export const identityId = !import.meta.env
  ? _dev_identityId
  : import.meta.env.DEV
  ? _dev_identityId
  : location.host.split('.')?.[0];

/**
 * env
 * @param mode
 * @param env
 */
export function getEnv(mode: string) {
  const config = {
    routerBase: '/', // 路由基本路径
    viteBase: '/', // 打包的基本路径
    apiUrl: '',
  };

  // 打包环境
  const BuildEnv = ['devTest', 'sit', 'uat'];

  // Force using relative API paths for all environments in Kubernetes deployment
  // This ensures API calls are properly routed through our Nginx configuration
  config.apiUrl = ``;
  
  // Original environment-specific URLs (commented out for reference)
  // if (mode === 'uat') {
  //   // uat环境
  //   config.apiUrl = `https://${identityId}.imsz.online`;
  // } else if (mode === 'sit') {
  //   // sit环境
  //   config.apiUrl = `http://${identityId}.im-sit-dreaminglife.cn`;
  // } else if (mode === 'devTest') {
  //   // 线上dev环境
  //   config.apiUrl = `http://${identityId}.im-dreaminglife.cn`;
  // } else {
  //   // 本地开发
  //   config.apiUrl = ``;
  // }

  if (BuildEnv.includes(mode)) {
    // 打包环境
    if (['devTest', 'sit'].includes(mode)) {
      // 打包到子路径(根据模式名字 作为 子路径名字)
      config.routerBase = `/console/`;
      config.viteBase = `/console/`;
    } else {
      // uat
      // 打包到根路径
    }
  } else {
    // 本地开发环境
  }

  return config;
}
